import { handleActions } from "redux-actions";

import { removeById, updateById } from "utils";

const getRootType = (type = "Note") => type.charAt(0).toLowerCase() + type.slice(1);

export default handleActions(
  {
    POSTS: {
      GET: {
        FULFILLED: (_, action) => ({
          posts: action.payload.posts,
        }),
      },
    },

    POST: {
      DELETE: {
        FULFILLED: ({ posts }, { meta: { postID } }) => ({
          posts: removeById(posts, postID),
        }),
      },

      CREATE: {
        FULFILLED: ({ posts }, { meta: { type }, payload }) => ({
          posts: [...posts, payload[getRootType(type)]],
        }),
      },

      SAVE: {
        FULFILLED: ({ posts }, { meta: { type }, payload }) => ({
          posts: updateById(posts, payload[getRootType(type)]),
        }),
      },
    },
  },
  {},
  { namespace: "_" }
);
